import {
    SpecialVisualisationParams,
    SpecialVisualization,
    SpecialVisualizationSvelte,
} from "../SpecialVisualization"
import { Feature, LineString } from "geojson"
import Translations from "../i18n/Translations"
import SvelteUIElement from "../Base/SvelteUIElement"
import ExportFeatureButton from "./ExportFeatureButton.svelte"
import { GeoOperations } from "../../Logic/GeoOperations"

class ExportAsGpxVis extends SpecialVisualizationSvelte {
    funcName = "export_as_gpx"
    docs = "Exports the selected feature as GPX-file"
    args = []
    needsUrls = []

    constr({ tags, feature, layer }: SpecialVisualisationParams) {
        if (feature.geometry.type !== "LineString") {
            return undefined
        }
        const t = Translations.t.general.download

        return new SvelteUIElement(ExportFeatureButton, {
            tags,
            feature,
            layer,
            mimetype: "{gpx=application/gpx+xml}",
            extension: "gpx",
            construct: (feature: Feature<LineString>, title: string) =>
                GeoOperations.toGpx(feature, title),
            helpertext: t.downloadGpxHelper,
            maintext: t.downloadFeatureAsGpx,
        })
    }
}

class ExportAsGeojsonVis extends SpecialVisualizationSvelte {
    funcName = "export_as_geojson"
    docs = "Exports the selected feature as GeoJson-file"
    args = []

    constr({ tags, feature, layer }: SpecialVisualisationParams) {
        const t = Translations.t.general.download
        return new SvelteUIElement(ExportFeatureButton, {
            tags,
            feature,
            layer,
            mimetype: "application/vnd.geo+json",
            extension: "geojson",
            construct: (feature: Feature<LineString>) => JSON.stringify(feature, null, "  "),
            maintext: t.downloadFeatureAsGeojson,
            helpertext: t.downloadGeoJsonHelper,
        })
    }
}

export class DataExportVisualisations {
    public static initList(): SpecialVisualizationSvelte[] {
        return [new ExportAsGpxVis(), new ExportAsGeojsonVis()]
    }
}
